// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"6a28a9b0","266":"66f6e780","635":"1010e4b0","670":"2541a0d7","738":"94f5a01e","867":"996368d2"}[chunkId] + ".chunk.css";
};